;(function() {
  $('.highlight-slider__slick-slider').slick({
    slidesToShow: 4,
    arrows: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.scrolling-message__slick-slider').slick({
    slidesToShow: 6,
    variableWidth: true,
    centerMode: true,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.stockists-item__slick-slider').slick({
    slidesToShow: 5,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
  
  $('.quote-card__slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 700,
    arrows: false,
    dots: true,
    easing: "ease-out",
  });

  $(window).on('load', function() {
    $("#misresenas").slick({
      arrows:false,
      autoplay:true
    });
 });

  $('.js-product-slider').slick({
    infinite: false
  });

  $(function() {
    if ( document.location.href.indexOf('challenge#ContactFooter') > -1 ) {
      $(window).scrollTop(0);
    }
  });

}());
